import React from "react";
import { useNavigate } from "react-router-dom";
import "./style.css";

const FirstVideo = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate("/contact");
  };

  return (
    <div className="min-h-[82vh] mt-[-1.5rem] md:mt-7 mb-4 flex items-stretch home-hero-section-conatiner">
      <div className="w-full px-0  max-w-screen-xl flex flex-col justify-center m-auto home-main-container">
        <div className=" md:flex-row items-center justify-between  gap-4 md:gap-0 py-2 md:py-6 home-main-container-row">
          {/* Left Side: Text Content */}
          <div className="flex-1 text-center md:text-center px-2 md:px-4 lg:px-6 mb-2 md:mb-0">
            <h3 className="mb-2 Hero-section-main-heading  font-poppins">
              In Every Moment That Matters
            </h3>
            <p className="text-gray-600 text-[1.4rem] font-gilroy">
              Reliable support, right when it’s needed, Across Assist is the
              silent strength behind every smooth customer experience, is
              seamless and stress free. That’s what we deliver. We deliver a
              promise, A promise that you can offer your customers a level of
              assurance that’s unmatched, because you’re backed by{" "}
              <b>Across Assist</b>
            </p>
            {/* <button
              onClick={handleGetStarted}
              className="mt-6 text-black font-poppins text-base px-8 py-3 rounded-lg shadow-md transition-all duration-300 hover:shadow-lg"
              style={{
                textTransform: "none",
                border: "1px solid",
                borderImage: "#3b82f6",
              }}
            >
              Get Started with Across Assist
            </button> */}
          </div>
          <div className="flex-1 mt-2 flex justify-center md:justify-center items-center w-full px-0 md:px-2">
            <div className="w-[90vw] sm:w-[70vw] md:w-[82vw] lg:w-[90vw] max-w-[900px] min-w-[220px] md:h-[450px] overflow-hidden bg-black">
              <video
                autoPlay
                loop
                muted
                playsInline
                className="w-full h-auto block relative"
                style={{ borderRadius: "inherit" }}
              >
                <source
                  src={require("../../assets/video/HomeVideoNew.mp4")}
                  type="video/mp4"
                />
              </video>
            </div>
          </div>
          {/* <div className="flex-1 text-center md:text-left px-2 md:px-4 lg:px-6 mb-2 md:mb-0">
            <h3 className="mb-2 Hero-section-main-heading  font-poppins">
              In Every Moment That Matters
            </h3>
            <p className="text-gray-600 text-[1.4rem] font-gilroy">
              Reliable support, right when it’s needed, Across Assist is the
              silent strength behind every smooth customer experience, is
              seamless and stress free. That’s what we deliver. We deliver a
              promise, A promise that you can offer your customers a level of
              assurance that’s unmatched, because you’re backed by Across Assist
            </p>
            <button
              onClick={handleGetStarted}
              className="mt-6 text-black font-poppins text-base px-8 py-4 rounded-lg shadow-md transition-all duration-300 hover:shadow-lg"
              style={{
                textTransform: "none",
                border: "1px solid",
                borderImage: "#3b82f6",
              }}
            >
              Get Started with Across Assist
            </button>
          </div>
          <div className="flex-1 flex justify-center md:justify-end items-center w-full px-0 md:px-2">
            <div className="w-[90vw] sm:w-[70vw] md:w-[42vw] lg:w-[38vw] max-w-[600px] min-w-[220px] overflow-hidden bg-black">
              <video
                autoPlay
                loop
                muted
                playsInline
                className="w-full h-auto block relative"
                style={{ borderRadius: "inherit" }}
              >
                <source
                  src={require("../../assets/video/HomeVideoNew.mp4")}
                  type="video/mp4"
                />
              </video>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default FirstVideo;
